<template>
  <a-modal
    :title="language['common.action']"
    :width="800"
    :ok=false
    :visible="visible"
    :confirmLoading="confirmLoading"
    :okButtonProps="{ props: {disabled: disableSubmit} }"
    @ok="handleOk"
    :okText="this.$store.getters.language['common.okButton']"
    @cancel="handleCancel"
    :cancelText="language['common.closeButton']">

    <a-spin :spinning="confirmLoading">
      <a-form-model ref="form" :model="model" :rules="validatorRules">
        <a-form-model-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          :label="language['depart.management.oldDepartName']"
          prop="departName"
          :hidden="false"
        >
          <!--hasFeedback >-->
          <a-input id="departName" placeholder="" v-model="model.departName" :disabled="true"/>
        </a-form-model-item>
<!--        <a-form-model-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          :label="language['common.type']"
          prop="transferType"
          :hidden="false" >
          <a-radio-group v-model="model.transferType" @change="handleOrgChange">
            <a-radio :value="1">{{language['common.new']}}{{language['depart']}}</a-radio>
            <a-radio :value="2">{{language['common.originalDepart']}}</a-radio>
          </a-radio-group>
        </a-form-model-item>-->
        <a-form-model-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          :label="language['depart.management.transfer']"
          :hidden="false" >
          <a-radio-group v-model="isTransfer" @change="transferChange" >
            <a-radio value="2">{{ language['depart.management.transfer.now'] }}</a-radio>
            <a-radio value="1">{{ language['depart.management.transfer.wait'] }}</a-radio>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item v-if="showEffectiveDate"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          :label="language['system.effectiveDate']" >
          <a-date-picker
            style="width: 100%"
            :placeholder="language['common.pleaseChoose']+language['system.effectiveDate']"
            v-model="model.effectiveDate"
            :disabled-date="disabledDate"
            :format="dateFormat"
            :getCalendarContainer="node => node.parentNode"/>
        </a-form-model-item>

        <a-form-model-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          prop="parentId"
          :label="language['depart.management.FDepart']">
          <a-tree-select
            style="width:100%"
            :dropdownStyle="{maxHeight:'200px',overflow:'auto'}"
            :treeData="treeData"
            v-model="model.parentId"
            :placeholder="language['common.not']">
          </a-tree-select>
        </a-form-model-item>

        <div v-show="isPreviousOrNot">
          <a-form-model-item
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
            :label="language['depart.management.departName']"
            prop="departNameNew"
            :hidden="false"
          >
            <a-input id="departNameNew" :placeholder="language['common.pleaseInput']+language['depart.management.departName']" v-model="model.departNameNew"/>
          </a-form-model-item>
          <a-form-model-item
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
            :label="language['depart.management.orgCategory']">
           <template v-if="seen">
              <a-radio-group v-model="model.orgCategory" :placeholder="language['common.pleaseChoose']+language['depart.management.orgCategory']">
                <a-radio value="1">
                  {{language['common.company']}}
                </a-radio>
              </a-radio-group>
            </template>
            <template v-else>
              <a-radio-group v-model="model.orgCategory" :placeholder="language['common.pleaseChoose']+language['depart.management.orgCategory']">
                <a-radio value="2">
                  {{language['depart']}}
                </a-radio>
                <a-radio value="3">
                  {{language['common.post']}}
                </a-radio>
              </a-radio-group>
         </template>
          </a-form-model-item>
          <a-form-model-item
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
            prop="mobile"
            :label="language['depart.management.mobile']">
            <a-input :placeholder="language['common.pleaseInput']+language['depart.management.mobile']" v-model="model.mobile"/>
          </a-form-model-item>
          <a-form-model-item
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
            :label="language['depart.management.fax']">
            <a-input :placeholder="language['common.pleaseInput']+language['depart.management.fax']" v-model="model.fax"/>
          </a-form-model-item>
          <a-form-model-item
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
            :label="language['depart.management.address']">
            <a-input :placeholder="language['common.pleaseInput']+language['depart.management.address']" v-model="model.address"/>
          </a-form-model-item>
          <a-form-model-item
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
            :label="language['common.sort']">
            <a-input-number v-model="model.departOrder"/>
          </a-form-model-item>

          <a-form-model-item
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
            :label="language['depart.management.expenseCode']">
            <a-input :placeholder="language['common.pleaseInput']+language['depart.management.expenseCode']" v-model="model.expenseCode"/>
          </a-form-model-item>
          <a-form-model-item
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
            prop="levelNo"
            :label="language['depart.management.levelNo']">
            <j-dict-select-tag v-model="model.levelNo" :placeholder="language['common.pleaseChoose']+language['depart.management.levelNo']" :allowClear="true" dictCode="depart_category"/>
          </a-form-model-item>
          <a-form-model-item
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
            :label="language['depart.management.deportDirector']">
            <j-select-user :placeholder="language['common.pleaseChoose']+language['depart.management.deportDirector']" :multiple="false" v-model="model.departChief"/>
          </a-form-model-item>

          <a-form-model-item
            prop="artificialPerson"
            :label="language['depart.management.artificialPerson']"
            :labelCol="labelCol"
            :wrapperCol="wrapperCol">
            <a-select
              style="width: 100%"
              allowClear
              :placeholder="language['common.pleaseChoose']+language['depart.management.artificialPerson']"
              v-model="model.artificialPerson">
              <a-select-option v-for="(item,index) in artificialPersonList" :key="index.toString()" :value="item.id">
                {{ item.legalpersonName }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item
            prop="siteCode"
            :label="language['depart.management.siteCode']"
            :labelCol="labelCol"
            :wrapperCol="wrapperCol">
            <a-select
              style="width: 100%"
              allowClear
              :placeholder="language['common.pleaseChoose']+language['depart.management.siteCode']"
              v-model="model.siteCode">
              <a-select-option v-for="(item,index) in siteCodeList" :key="index.toString()" :value="item.id">
                {{ item.factoryName }}
              </a-select-option>
            </a-select>
          </a-form-model-item>

          <a-form-model-item
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
            :label="language['depart.management.memo']">
            <a-textarea :placeholder="language['common.pleaseInput']+language['depart.management.memo']" v-model="model.memo"/>
          </a-form-model-item>
        </div>

      </a-form-model>
    </a-spin>
  </a-modal>
</template>

<script>
  import { httpAction,getAction } from '@/api/manage'
  import { queryIdTree,queryDepartTreeList } from '@/api/api'
  import { get, pick } from 'lodash';
  import ATextarea from 'ant-design-vue/es/input/TextArea'
  import moment from "moment";
  export default {
    name: "DepartTransferModal",
    components: { ATextarea },
    computed:{
      language() {
        return this.$store.getters.language
      },
    },
    data () {
      return {
        oldParentId:'',
        showEffectiveDate:false,
        isTransfer:'2',

        iExpandedKeys: [],
        allTreeKeys:[],
        allTreeNodes:[],
        treeData: [],
        nextDepartOptions:[],
        isPreviousOrNot:false,
        dateFormat:"YYYY-MM-DD",
        artificialPersonList:[{
          id:'',
          applicationName:''
        }],
        siteCodeList:[{
          id:'',
          xxx:''
        }],
        departTree:[],
        orgTypeData:[],
        phoneWarning:'',
        departName:"",
        departNameNew:"",
        title:"操作",
        seen:false,
        visible: false,
        condition:true,
        disableSubmit:false,
        model: {},
        defaultModel:{
          departOrder:0,
          orgCategory:'1'
        },
        menuhidden:false,
        menuusing:true,
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },

        confirmLoading: false,
        validatorRules:{
          departName:[{ required: true, message: '请输入机构/部门名称!' }],
          departNameNew:[{ required: true, message: '请输入部门名称!' }],
          orgCode:[{ required: true, message: '请输入机构编码!' }],
          mobile: [{validator:this.validateMobile}],
          orgCategory:[{required: true, message: '请输入机构类型!'}],
          departChief:[{ required: true, message: '请选择部门主管!' }],
          levelNo:[{ required: true, message: '请选择组织层级!' }],
          transferType:[{ required: true, message: '请选择转移类型!' }],
          parentId:[{ required: true, message: '请选择上级部门!' }],
          // artificialPerson: [{ required: true, message: '请选择法人!' }],
        },
        url: {
          add: "/sys/sysDepart/add",
          transferDepart: "/sys/sysDepart/transferDepart",
        },
        dictDisabled:true,
      }
    },
    created () {
      this.getLegalPersons();
      this.getDepartSites();
      // this.loadTreeData();
    },
    methods: {
      transferChange(e){
        let value = e.target.value;
        if(value=='1'){
          this.showEffectiveDate = true;
        }else{
          this.showEffectiveDate = false;
          this.model.effectiveDate = null;
        }

      },
      backDepartInfo(info) {
        this.model.departIds = this.model.selectedDeparts;
        this.nextDepartOptions = info.map((item,index,arr)=>{
          let c = {label:item.text, value: item.value+""}
          return c;
        })
      },
      handleOrgChange(e){
        let value = e.target.value;
        if(value=='1'){
          this.isPreviousOrNot = true;
        } else {
          this.isPreviousOrNot = false;
        }
      },
      disabledDate(current) {
        return current && current <= moment().endOf('day')-24*60*60*1000
      },
      getLegalPersons(){
        getAction("/sys/sysDepart/getLegalPersonList").then((res) => {//{id: this.model.artificialPerson}
          if (res.success) {
            this.artificialPersonList = res.result;
          }
        })
      },
      getDepartSites(){
        getAction("/sys/sysDepart/getFactoryList").then((res) => {//, {id: this.model.siteCode}
          if (res.success) {
            this.siteCodeList = res.result;
          }
        })
      },
      loadTreeData(id){
        var that = this
        that.treeData = []
        that.departTree = []
        queryDepartTreeList({'applicationCode':this.$store.getters.applicationCode}).then((res) => {
          if (res.success) {
            //部门全选后，再添加部门，选中数量增多
            this.allTreeKeys = [];
            for (let i = 0; i < res.result.length; i++) {
              let temp = res.result[i]
              // this.getDisabledKeys(temp, id);
              that.treeData.push(temp)
              that.departTree.push(temp)
              that.setThisExpandedKeys(temp,id)
              that.getAllKeys(temp);
              // console.log(temp.id)
            }
            this.loading = false
          }
        })
        /*var that = this;
        queryIdTree().then((res)=>{
          if(res.success){
            that.departTree = [];
            for (let i = 0; i < res.result.length; i++) {
              let temp = res.result[i];
              that.departTree.push(temp);
            }
          }
        });
        that.treeData = []
        queryDepartTreeList().then((res) => {
          if (res.success) {
            //部门全选后，再添加部门，选中数量增多
            this.allTreeKeys = [];
            for (let i = 0; i < res.result.length; i++) {
              let temp = res.result[i]
              that.treeData.push(temp)
              that.setThisExpandedKeys(temp)
              that.getAllKeys(temp);
              // console.log(temp.id)
            }
            this.loading = false
          }
        })*/
      },
      getDisabledKeys(node) {
        /*if(node.id == id){
          node.disabled = true;
          return;
        }*/
        node.disabled = true;
        if (node.children && node.children.length > 0) {
          for (let a = 0; a < node.children.length; a++) {
            // this.getDisabledKeys(node.children[a], id)
            this.getDisabledKeys(node.children[a])
          }
        }
      },
      setThisExpandedKeys(node,id) {
        if(node.id == id)this.getDisabledKeys(node);
        if (node.children && node.children.length > 0) {
          this.iExpandedKeys.push(node.key)
          for (let a = 0; a < node.children.length; a++) {
            this.setThisExpandedKeys(node.children[a],id)
          }
        }
      },
      getAllKeys(node) {
        // console.log('node',node);
        this.allTreeKeys.push(node.key)
        if (node.children && node.children.length > 0) {
          for (let a = 0; a < node.children.length; a++) {
            this.getAllKeys(node.children[a])
          }
        }
      },
      add (depart) {
        if(depart){
          this.seen = false;
          this.dictDisabled = false;
        }else{
          this.seen = true;
          this.dictDisabled = true;
        }
        this.edit(depart);
      },
      edit (record) {
        this.visible = true;
        this.model = Object.assign({}, this.defaultModel, record)
        this.model.parentId = record?record.parentId:null;
        this.model.transferType = '2';
        this.loadTreeData(this.model.id);
         if(this.seen){
           this.model.orgCategory = '1';
         }else{
           this.model.orgCategory = '2';
         }
        this.oldParentId = record?record.parentId:null;
         this.isTransfer='2';

      },
      close () {
        this.$emit('close');
        this.disableSubmit = false;
        this.visible = false;
        this.isPreviousOrNot = false;
        this.$refs.form.resetFields();
        this.showEffectiveDate = false;
        this.oldParentId = "";
      },
      handleOk () {
        const that = this;
        // 触发表单验证
        this.$refs.form.validate(valid => {
          this.model.originDepartId =this.oldParentId;
          if (valid) {
            that.confirmLoading = true;
            httpAction(this.url.transferDepart,this.model,"post").then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                // that.loadTreeData();
                that.$emit('ok');
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
              that.close();
            })
          }else{
            if(this.model.transferType == '2' && this.model.parentId != '' && this.model.parentId != null && this.model.parentId != undefined){
              if(that.isTransfer=='1' && !that.model.effectiveDate){
                that.$message.warning(this.language['common.pleaseChoose']+this.language['system.effectiveDate']);
                return false
              }
              if(this.oldParentId === this.model.parentId){
                that.$message.warning(this.language['depart.management.warning.departNotMoving']);
                return false
              }
              that.confirmLoading = true;
              httpAction(this.url.transferDepart,this.model,"post").then((res)=>{
                if(res.success){
                  that.$message.success(res.message);
                  // that.loadTreeData();
                  that.$emit('ok');
                }else{
                  that.$message.warning(res.message);
                }
              }).finally(() => {
                that.confirmLoading = false;
                that.close();
              })
            } else {
              return false;
            }
          }
        })
      },
      handleCancel () {
        this.close()
      },
      validateMobile(rule,value,callback){
        if (!value || new RegExp(/^1([38][0-9]|4[579]|5[0-3,5-9]|6[6]|7[0135678]|9[89])\d{8}$/).test(value)){
          callback();
        }else{
          callback(this.language['depart.management.phone.format.incorrect']);
        }

      }
    }
  }
</script>

<style scoped>

</style>